// extracted by mini-css-extract-plugin
export default {"footerSection":"Footer_footerSection__q6hVJ","footerText":"Footer_footerText__rlW5Y"};